export default "__VITE_ASSET__D4O8avU5__"